import React, { useState, useEffect } from 'react'
import Hero from '../components/Hero';
import BodyContent from './BodyContent';
import loader from '../assets/images/logo-blanco.gif'
import '../css/loader.css'
import PopUpPromo from '../components/PopUpPromo';
export default function Home() {

    //console.log("🏠 Renderizando Home");

    const [loading, setLoading] = useState(false);

      useEffect(() => {
        const timer = setTimeout(() => {
          setLoading(false);
        }, 3500);

        return () => clearTimeout(timer);
}, []);
  return (
    <>

    <div>
      {loading ? (
        <div className='loader_box'>
          <div className='stadium_glow'></div>
          <div className='loader_content'>          
              <img src={loader} alt="Loader GIF" className='loader_gif' />
            <h2>Navega la ruta del fútbol 2026</h2>

            <div className='loading_bar'>
              <span></span>
            </div>
        </div>

      </div>       
      ) : (
        <div>
          <Hero />
            {/*<PopUpPromo />*/}
          <BodyContent />
       
        </div>
      )}
    </div>

    </>
  )
}
